import { Uwi } from "models";

import { UwidFormatT, WellInfoT } from "../context";

/**
 * Formats a well identifier based on the selected format type
 * @param well - The well information object containing id and label
 * @param format - The desired format: 'entityName', 'uwid', 'api10', or 'mosaic'
 * @returns The formatted well identifier string
 */
/** Shared: Uwi holds no per-call state, and one instance per call cost 50k
 * allocations per format change over a full filter. */
const uwiConverter = new Uwi();

export const formatWellIdentifier = (well: WellInfoT, format: UwidFormatT): string => {
  if (format === "entityName") {
    return well.label;
  }
  if (format === "uwid") {
    return well.id;
  }

  switch (format) {
    case "api10":
      return uwiConverter.toAPI10(well.id);
    case "mosaic":
      return uwiConverter.toMosaic(well.id);
    default:
      return well.label;
  }
};
